import { configureStore } from "@reduxjs/toolkit";
import { createWrapper } from "next-redux-wrapper";
import rootReducer from "./reducer/index";

let store = null;

export function initializeStore(initialState = {}) {
  store = configureStore({
    reducer: rootReducer,
    preloadedState: initialState,
    // Enable Redux DevTools action stack traces (Trace tab) outside production.
    devTools: process.env.NODE_ENV !== "production" && {
      trace: true,
      traceLimit: 25,
    },
  });

  return store;
}

export function getStore() {
  return store;
}

export const wrapper = createWrapper(initializeStore);

export type AppStore = ReturnType<typeof initializeStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
